import React, { useState, useEffect, useContext, useRef } from "react";

import * as Yup from "yup";
import { Formik, Form, Field, FieldArray } from "formik";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { Chip, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Select, Switch, Typography, Avatar, RadioGroup, Radio, FormLabel } from "@material-ui/core";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import moment from "moment"
import { AuthContext } from "../../context/Auth/AuthContext";
import { isArray, capitalize } from "lodash";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import AttachFile from "@material-ui/icons/AttachFile";
import { head } from "lodash";
import ConfirmationModal from "../ConfirmationModal";
import MessageVariablesPicker from "../MessageVariablesPicker";
import useQueues from "../../hooks/useQueues";
import UserStatusIcon from "../UserModal/statusIcon";
import { Facebook, Instagram, WhatsApp, Mic, Stop, PlayArrow, Delete as DeleteIcon, Replay } from "@material-ui/icons";
import MicRecorder from "mic-recorder-to-mp3";

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
	// multFieldLine: {
	// 	display: "flex",
	// 	"& > *:not(:last-child)": {
	// 		marginRight: theme.spacing(1),
	// 	},
	// },

	btnWrapper: {
		position: "relative",
	},

	buttonProgress: {
		color: green[500],
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},
	// Destaque de aviso (laranja) no campo de data/hora
	warnField: {
		'& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
			borderColor: ((theme.palette.warning && theme.palette.warning.main) || '#ff9800') + ' !important',
		},
		'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: ((theme.palette.warning && theme.palette.warning.main) || '#ff9800') + ' !important',
		},
		'& .MuiFormLabel-root': {
			color: ((theme.palette.warning && theme.palette.warning.main) || '#ff9800') + ' !important',
		},
	},
	helperWarn: {
		color: ((theme.palette.warning && theme.palette.warning.main) || '#ff9800') + ' !important',
	},
	// formControl: {
	// 	margin: theme.spacing(1),
	// 	minWidth: 120,
	// },
}));

const getScheduleSchema = (mode = "text") =>
	Yup.object().shape({
		body: mode === "text"
			? Yup.string().min(5, "Mensagem muito curta").required("Obrigatório")
			: Yup.string().nullable(),
		contactId: Yup.number().required("Obrigatório"),
		sendAt: Yup.string()
			.required("Obrigatório")
			.test(
				"min-10-min",
				"Agende para pelo menos 10 minutos à frente.",
				function (value) {
					if (!value) return false;
					const selected = moment(value);
					if (!selected.isValid()) return false;
					// Exige estritamente 10 minutos à frente
					const min = moment().add(10, "minutes");
					return selected.isSameOrAfter(min, "minute");
				}
			),
		enviarQuantasVezes: Yup.number()
			.min(1, "Mínimo 1")
			.max(25, "Máximo 25")
			.nullable()
	});

const ScheduleModal = ({ open, onClose, scheduleId, contactId, cleanContact, reload, initialSchedule }) => {
	const classes = useStyles();
	const history = useHistory();
	const { user } = useContext(AuthContext);
	const isMounted = useRef(true);
	const { companyId } = user;

	const initialState = {
		body: "",
		contactId: "",
		sendAt: moment().add(1, 'hour').format('YYYY-MM-DDTHH:mm'),
		sentAt: "",
		openTicket: "enabled",
		ticketUserId: "",
		queueId: "",
		statusTicket: "closed",
		intervalo: 1,
		valorIntervalo: 0,
		enviarQuantasVezes: 1,
		tipoDias: 4,
		assinar: false
	};

	const initialContact = {
		id: "",
		name: "",
		channel: "",
		number: ""
	}

	const [schedule, setSchedule] = useState(initialState);
	const [currentContact, setCurrentContact] = useState(initialContact);
	const [contacts, setContacts] = useState([initialContact]);
	const [intervalo, setIntervalo] = useState(1);
	// const [valorIntervalo, setValorIntervalo] = useState(initialContact);
	// const [enviarQuantasVezes, setEnviarQuantasVezes] = useState(initialContact);
	const [tipoDias, setTipoDias] = useState(4);
	const [attachment, setAttachment] = useState(null);
	const attachmentFile = useRef(null);
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const messageInputRef = useRef();
	const [channelFilter, setChannelFilter] = useState("whatsapp");
	const [whatsapps, setWhatsapps] = useState([]);
	const [selectedWhatsapps, setSelectedWhatsapps] = useState([]);
	const [loading, setLoading] = useState(false);
	const [queues, setQueues] = useState([]);
	const [allQueues, setAllQueues] = useState([]);
	const [selectedUser, setSelectedUser] = useState(null);
	const [selectedQueue, setSelectedQueue] = useState(null);
	const { findAll: findAllQueues } = useQueues();
	const [options, setOptions] = useState([]);
	const [searchParam, setSearchParam] = useState("");

	// Controle de data mínima e aviso local (minimo permitido: 10 minutos)
	const [minSendAt, setMinSendAt] = useState(
		moment().add(10, 'minutes').format('YYYY-MM-DDTHH:mm')
	);
	const [sendAtWarn, setSendAtWarn] = useState("");

	// Modo de mensagem: texto/anexo ou áudio gravado
	const [messageType, setMessageType] = useState("text"); // 'text' | 'audio'
	// Gravação de áudio
	const [isRecording, setIsRecording] = useState(false);
	const [recordedBlob, setRecordedBlob] = useState(null);
	const [recordedFile, setRecordedFile] = useState(null);
	const [audioUrl, setAudioUrl] = useState("");
	const [recordingError, setRecordingError] = useState("");
	const [elapsedMs, setElapsedMs] = useState(0);
	const mediaRecorderRef = useRef(null);
	const chunksRef = useRef([]);
	const streamRef = useRef(null);
	const timerRef = useRef(null);
	const Mp3Recorder = useRef(new MicRecorder({ bitRate: 128 }));

	// Gera um nome de arquivo amigável quando o File/Blob não possui .name
	const guessExtByMime = (mime) => {
		switch (mime) {
			case "image/jpeg":
			case "image/jpg":
				return "jpg";
			case "image/png":
				return "png";
			case "image/webp":
				return "webp";
			case "application/pdf":
				return "pdf";
			case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
				return "docx";
			case "application/msword":
				return "doc";
			case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
				return "xlsx";
			case "application/vnd.ms-excel":
				return "xls";
			case "application/zip":
			case "application/x-zip-compressed":
				return "zip";
			case "video/mp4":
				return "mp4";
			case "audio/mpeg":
			case "audio/mp3":
				return "mp3";
			case "audio/ogg":
				return "ogg";
			case "audio/webm":
			case "video/webm":
				return "webm";
			default:
				return "bin";
		}
	};

	const buildAttachmentFilename = (file) => {
		if (!file) return "anexo";
		if (file.name && typeof file.name === "string" && file.name.trim() !== "") {
			return file.name;
		}
		const ext = guessExtByMime(file.type || "");
		const ts = moment().format("YYYYMMDD-HHmmss");
		return `anexo-${ts}.${ext}`;
	};

	// Formatador simples mm:ss
	const fmt = (ms) => {
		const total = Math.max(0, Math.floor(ms / 1000));
		const m = String(Math.floor(total / 60)).padStart(2, '0');
		const s = String(total % 60).padStart(2, '0');
		return `${m}:${s}`;
	};

	useEffect(() => {
		return () => {
			// cleanup media
			try { if (timerRef.current) clearInterval(timerRef.current); } catch {}
			try { if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') mediaRecorderRef.current.stop(); } catch {}
			try { if (streamRef.current) streamRef.current.getTracks().forEach(t => t.stop()); } catch {}
			try { if (audioUrl) URL.revokeObjectURL(audioUrl); } catch {}
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	useEffect(() => {
		if (isMounted.current) {
			const loadQueues = async () => {
				const list = await findAllQueues();
				setAllQueues(list);
				setQueues(list);
			};
			loadQueues();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (searchParam.length < 3) {
			setLoading(false);
			setSelectedQueue("");
			return;
		}
		const delayDebounceFn = setTimeout(() => {
			setLoading(true);
			const fetchUsers = async () => {
				try {
					const { data } = await api.get("/users/");
					setOptions(data.users);
					setLoading(false);
				} catch (err) {
					setLoading(false);
					toastError(err);
				}
			};

			fetchUsers();
		}, 500);
		return () => clearTimeout(delayDebounceFn);
	}, [searchParam]);

	useEffect(() => {
		api
			.get(`/whatsapp/filter`, { params: { session: 0, channel: channelFilter } })
			.then(({ data }) => {
				// Mapear os dados recebidos da API para adicionar a propriedade 'selected'
				const mappedWhatsapps = data.map((whatsapp) => ({
					...whatsapp,
					selected: false,
				}));

				setWhatsapps(mappedWhatsapps);
				if (mappedWhatsapps.length && mappedWhatsapps?.length === 1){
					setSelectedWhatsapps(mappedWhatsapps[0].id)
				}
			});
	}, [currentContact, channelFilter])

	useEffect(() => {
		if (contactId && contacts.length) {
			const contact = contacts.find(c => c.id === contactId);
			if (contact) {
				setCurrentContact(contact);
			}
		}
	}, [contactId, contacts]);

	useEffect(() => {
		const { companyId } = user;
			if (open) {
				// Ao abrir o modal, recalcula o mínimo dinâmico (10 minutos)
				setMinSendAt(moment().add(10, 'minutes').format('YYYY-MM-DDTHH:mm'));
			try {
				(async () => {
					const { data: contactList } = await api.get('/contacts/list', { params: { companyId: companyId } });
					let customList = contactList.map((c) => ({
						id: c.id,
						name: c.name,
						channel: c.channel,
						number: c.number,
						urlPicture: c.urlPicture || c.profilePicUrl || c.avatarUrl || c.thumbnailUrl || "",
						profilePicUrl: c.profilePicUrl || c.urlPicture || c.avatarUrl || c.thumbnailUrl || "",
					}));
					if (isArray(customList)) {
						setContacts([{ id: "", name: "", channel: "", number: "" }, ...customList]);
					}
					// Preferência da duplicação: se vier initialSchedule, ele define o contactId e demais campos
					if (!scheduleId && initialSchedule) {
						const merged = {
							...initialState,
							...initialSchedule,
							mediaPath: null,
							mediaName: null,
						};
						setSchedule(merged);
						// Ajustar seleção de WhatsApp caso venha preenchida
						if (initialSchedule.whatsappId) {
							setSelectedWhatsapps(initialSchedule.whatsappId);
						}
						// Se vier com contactId, tentar posicionar o currentContact
						const found = customList.find(c => c.id === initialSchedule.contactId);
						setCurrentContact(found || initialContact);
						setChannelFilter((found && found.channel) || "whatsapp");
					} else if (contactId) {
						setSchedule(prevState => {
							return { ...prevState, contactId }
						});
					}

					if (!scheduleId) return;

					const { data } = await api.get(`/schedules/${scheduleId}`);
										setSchedule(prevState => {
												const incoming = moment(data.sendAt);
												// Ao carregar um agendamento antigo, ajusta para pelo menos 15 minutos à frente
												const min = moment().add(15, 'minutes');
												const adjusted = incoming.isValid() && incoming.isBefore(min)
													? min
													: incoming;
												return { ...prevState, ...data, sendAt: adjusted.format('YYYY-MM-DDTHH:mm') };
										});
					if (data.whatsapp) {
						setSelectedWhatsapps(data.whatsapp.id);
					}

					if (data.ticketUser) {
						setSelectedUser(data.ticketUser);
					}
					if (data.queueId) {
						setSelectedQueue(data.queueId);
					}

					if (data.intervalo) {
						setIntervalo(data.intervalo);
					}

					if (data.tipoDias) {
						setTipoDias(data.tipoDias);
					}

					setCurrentContact(data.contact);
				})()
			} catch (err) {
				toastError(err);
			}
		}
	}, [scheduleId, contactId, open, user]);

	const filterOptions = createFilterOptions({
		trim: true,
	});

		const handleClose = () => {
		onClose();
		setAttachment(null);
			setSchedule(initialState);
			setSelectedWhatsapps([]);
			setSelectedUser(null);
			setSelectedQueue(null);
			setTipoDias(4);
			setIntervalo(1);
				// limpar estado de áudio
				try { if (timerRef.current) clearInterval(timerRef.current); } catch {}
				try { if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') mediaRecorderRef.current.stop(); } catch {}
				try { if (streamRef.current) streamRef.current.getTracks().forEach(t => t.stop()); } catch {}
				try { if (audioUrl) URL.revokeObjectURL(audioUrl); } catch {}
				setIsRecording(false);
				setRecordedBlob(null);
				setRecordedFile(null);
				setAudioUrl("");
				setElapsedMs(0);
				chunksRef.current = [];
	};

	const handleAttachmentFile = (e) => {
		const file = head(e.target.files);
		if (file) {
			setAttachment(file);
		}
	};

	const handleChangeMessageType = (e) => {
		const val = e.target.value;
		setMessageType(val);
		setRecordingError("");
		if (val === "audio") {
			// limpamos anexos e texto não é obrigatório
			setAttachment(null);
			if (attachmentFile?.current) attachmentFile.current.value = null;
		} else {
			// limpamos áudio gravado
			if (audioUrl) try { URL.revokeObjectURL(audioUrl); } catch {}
			setAudioUrl("");
			setRecordedBlob(null);
			setRecordedFile(null);
			setElapsedMs(0);
			chunksRef.current = [];
			try { if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') mediaRecorderRef.current.stop(); } catch {}
			try { if (streamRef.current) streamRef.current.getTracks().forEach(t => t.stop()); } catch {}
			try { if (timerRef.current) clearInterval(timerRef.current); } catch {}
			setIsRecording(false);
		}
	};

	const startRecording = async () => {
		setRecordingError("");
		if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
			setRecordingError("Gravação não suportada neste navegador.");
			return;
		}
		try {
			await navigator.mediaDevices.getUserMedia({ audio: true });
			await Mp3Recorder.current.start();
			setIsRecording(true);
			setElapsedMs(0);
			if (timerRef.current) clearInterval(timerRef.current);
			timerRef.current = setInterval(() => setElapsedMs(prev => prev + 1000), 1000);
		} catch (err) {
			setRecordingError("Permita o acesso ao microfone para gravar.");
		}
	};

	const stopRecording = async () => {
		try { if (timerRef.current) clearInterval(timerRef.current); } catch {}
		try {
			const [buffer, blob] = await Mp3Recorder.current.stop().getMp3();
			if (blob && blob.size > 0) {
				setRecordedBlob(blob);
				const ts = moment().format('YYYYMMDD-HHmmss');
				const file = new File([blob], `gravacao-${ts}.mp3`, { type: 'audio/mpeg' });
				setRecordedFile(file);
				if (audioUrl) try { URL.revokeObjectURL(audioUrl); } catch {}
				const url = URL.createObjectURL(blob);
				setAudioUrl(url);
			}
		} catch (e) {
			setRecordingError("Falha ao finalizar a gravação.");
		} finally {
			setIsRecording(false);
		}
	};

	const playRecording = () => {
		if (!audioUrl) return;
		const a = new Audio(audioUrl);
		a.play();
	};

	const discardRecording = () => {
		try { if (timerRef.current) clearInterval(timerRef.current); } catch {}
		try { if (audioUrl) URL.revokeObjectURL(audioUrl); } catch {}
		setAudioUrl("");
		setRecordedBlob(null);
		setRecordedFile(null);
		setElapsedMs(0);
		chunksRef.current = [];
		setIsRecording(false);
	};

	const IconChannel = (channel) => {
		switch (channel) {
			case "facebook":
				return <Facebook style={{ color: "#3b5998", verticalAlign: "middle" }} />;
			case "instagram":
				return <Instagram style={{ color: "#e1306c", verticalAlign: "middle" }} />;
			case "whatsapp":
				return <WhatsApp style={{ color: "#25d366", verticalAlign: "middle" }} />
			default:
				return "error";
		}
	};

	const formatPhoneNumber = (number) => {
		if (!number) return "";
		
		// Remove todos os caracteres não numéricos
		const cleaned = number.replace(/\D/g, '');
		
		// Se tem 13 dígitos (55 + DDD + número)
		if (cleaned.length === 13 && cleaned.startsWith('55')) {
			const ddi = cleaned.substring(0, 2);
			const ddd = cleaned.substring(2, 4);
			const firstPart = cleaned.substring(4, 9);
			const secondPart = cleaned.substring(9, 13);
			return `+${ddi} (${ddd}) ${firstPart}-${secondPart}`;
		}
		
		// Se tem 12 dígitos (55 + DDD + número sem 9º dígito)
		if (cleaned.length === 12 && cleaned.startsWith('55')) {
			const ddi = cleaned.substring(0, 2);
			const ddd = cleaned.substring(2, 4);
			const firstPart = cleaned.substring(4, 8);
			const secondPart = cleaned.substring(8, 12);
			return `+${ddi} (${ddd}) ${firstPart}-${secondPart}`;
		}
		
		// Se tem 11 dígitos (DDD + número)
		if (cleaned.length === 11) {
			const ddd = cleaned.substring(0, 2);
			const firstPart = cleaned.substring(2, 7);
			const secondPart = cleaned.substring(7, 11);
			return `+55 (${ddd}) ${firstPart}-${secondPart}`;
		}
		
		// Se tem 10 dígitos (DDD + número sem 9º dígito)
		if (cleaned.length === 10) {
			const ddd = cleaned.substring(0, 2);
			const firstPart = cleaned.substring(2, 6);
			const secondPart = cleaned.substring(6, 10);
			return `+55 (${ddd}) ${firstPart}-${secondPart}`;
		}
		
		// Para outros formatos, retorna o número original
		return number;
	};

	const renderOption = option => {
		if (option.name) {
			const avatarSrc = option.urlPicture || option.profilePicUrl || "/nopicture.png";
			return (
				<span style={{ display: "flex", alignItems: "center" }}>
					<Avatar src={avatarSrc} alt={option.name} style={{ width: 56, height: 56, marginRight: 10 }} />
					{IconChannel(option.channel)}
					<Typography component="span" style={{ fontSize: 14, marginLeft: 10, display: "inline-flex", alignItems: "center", lineHeight: "2" }}>
						{option.name}{option.number && ` - ${formatPhoneNumber(option.number)}`}
					</Typography>
				</span>
			);
		} else {
			return `${i18n.t("newTicketModal.add")} ${option.name}`;
		}
	};
	const handleSaveSchedule = async values => {
		const scheduleData = {
			...values, userId: user.id, whatsappId: selectedWhatsapps, ticketUserId: selectedUser?.id || null,
			queueId: selectedQueue || null, intervalo: intervalo || 1, tipoDias: tipoDias || 4
		};
		// No modo áudio, o backend exige body mínimo de 5 chars; usamos um placeholder se vier vazio
		if (messageType === 'audio' && (!scheduleData.body || String(scheduleData.body).trim() === '')) {
			scheduleData.body = 'Audio gravado';
		}

		console.log("Enviando para API (PUT):", scheduleData);


		try {
			// Seleciona o arquivo a enviar conforme o modo
			const uploadFile = messageType === 'audio' ? recordedFile : attachment;
			if (scheduleId) {
				await api.put(`/schedules/${scheduleId}`, scheduleData);
				if (uploadFile != null) {
					const formData = new FormData();
					formData.append("file", uploadFile, buildAttachmentFilename(uploadFile));
					await api.post(
						`/schedules/${scheduleId}/media-upload`,
						formData
					);
				}
			} else {
				const { data } = await api.post("/schedules", scheduleData);
				if (uploadFile != null) {
					const formData = new FormData();
					formData.append("file", uploadFile, buildAttachmentFilename(uploadFile));
					await api.post(`/schedules/${data.id}/media-upload`, formData);
				}
			}
			// sucesso: retorno simples para o caller decidir fechar/resetar
			return { ok: true };
		} catch (err) {
			// Propaga o erro para o onSubmit decidir como tratar (inline ou toast)
			throw err;
		}
	};
	const handleClickMsgVar = async (msgVar, setValueFunc) => {
		const el = messageInputRef.current;
		const firstHalfText = el.value.substring(0, el.selectionStart);
		const secondHalfText = el.value.substring(el.selectionEnd);
		const newCursorPos = el.selectionStart + msgVar.length;

		setValueFunc("body", `${firstHalfText}${msgVar}${secondHalfText}`);

		await new Promise(r => setTimeout(r, 100));
		messageInputRef.current.setSelectionRange(newCursorPos, newCursorPos);
	};

	const deleteMedia = async () => {
		if (attachment) {
			setAttachment(null);
			attachmentFile.current.value = null;
		}

		if (schedule.mediaPath) {
			await api.delete(`/schedules/${schedule.id}/media-upload`);
			setSchedule((prev) => ({
				...prev,
				mediaPath: null,
			}));
			toast.success(i18n.t("scheduleModal.toasts.deleted"));
			if (typeof reload == "function") {
				reload();
			}
		}
	};

	return (
		<div className={classes.root}>
			<ConfirmationModal
				title={i18n.t("scheduleModal.confirmationModal.deleteTitle")}
				open={confirmationOpen}
				onClose={() => setConfirmationOpen(false)}
				onConfirm={deleteMedia}
			>
				{i18n.t("scheduleModal.confirmationModal.deleteMessage")}
			</ConfirmationModal>
			<Dialog
				open={open}
				onClose={handleClose}
				maxWidth="md"
				fullWidth
				scroll="paper"
			>
				<DialogTitle id="form-dialog-title">
					{schedule.status === 'ERRO' ? 'Erro de Envio' : `Mensagem ${capitalize(schedule.status)}`}
				</DialogTitle>
				<div style={{ display: "none" }}>
					<input
						type="file"
						accept=".png,.jpg,.jpeg"
						ref={attachmentFile}
						onChange={(e) => handleAttachmentFile(e)}
					/>
				</div>
				<Formik
					initialValues={schedule}
					enableReinitialize={true}
					validationSchema={getScheduleSchema(messageType)}
					onSubmit={async (values, actions) => {
						// Validação adicional para modo áudio
						if (messageType === 'audio') {
							if (!recordedFile) {
								toast.error('Grave um áudio para agendar.');
								actions.setSubmitting(false);
								return;
							}
						}
						try {
							// Regra: se menor que 10 min, ajusta automaticamente para 15 min e NÃO salva nesta tentativa
							const now = moment();
							const candidate = moment(values.sendAt);
							const min10 = moment(now).add(10, 'minutes');
							if (candidate.isValid() && candidate.isBefore(min10)) {
								const adjusted = moment().add(15, 'minutes').format('YYYY-MM-DDTHH:mm');
								// Ajusta o campo, mostra aviso e bloqueia salvar nesta tentativa
								actions.setFieldValue('sendAt', adjusted, false);
								actions.setFieldTouched('sendAt', true, true);
								actions.setFieldError('sendAt', 'Ajustamos o horário para 15 minutos à frente. Confira e clique em salvar novamente.');
								setSendAtWarn('Ajustamos para 15 minutos à frente por estar abaixo do mínimo de 10 minutos.');
								actions.setSubmitting(false);
								return;
							}
							await handleSaveSchedule(values);
							toast.success(i18n.t("scheduleModal.success"));
							if (typeof reload == 'function') {
								reload();
							}
							if (contactId) {
								if (typeof cleanContact === 'function') {
									cleanContact();
									history.push('/schedules');
								}
							}
							// resetar somente no sucesso
							setCurrentContact(initialContact);
							setSchedule(initialState);
							handleClose();
						} catch (err) {
							// Mantém o modal aberto e mostra erro inline no campo de data se for o caso
							const backendMsg = err?.response?.data?.error || err?.response?.data?.message || err?.message || '';
							// Detecta mensagens de mínimo vindas do backend (10/15/20) e padroniza para 10 no front
							const isMinError = /(10|15|20)\s*min/i.test(backendMsg) || /minuto/i.test(backendMsg) || /agendamento.*(10|15|20)/i.test(String(backendMsg));
							if (isMinError) {
								actions.setFieldTouched('sendAt', true, true);
								actions.setFieldError('sendAt', 'Agende para pelo menos 10 minutos à frente.');
							} else {
								toastError(err);
							}
						} finally {
							actions.setSubmitting(false);
						}
					}}
				>
					{({ touched, errors, isSubmitting, values, setFieldValue }) => (
						<Form>
						  <DialogContent dividers>
								<div className={classes.multFieldLine}>
									<FormControl
										variant="outlined"
										fullWidth
									>
										<Autocomplete
											fullWidth
						      value={currentContact}
											options={contacts}
											onChange={(e, contact) => {
												const contactId = contact ? contact.id : '';
												// Evita reinitialize do Formik: atualiza apenas o campo contactId
												setFieldValue('contactId', contactId, false);
												setCurrentContact(contact ? contact : initialContact);
												setChannelFilter(contact ? contact.channel : "whatsapp");
											}}
											getOptionLabel={(option) => option.name && option.number ? `${option.name} - ${formatPhoneNumber(option.number)}` : option.name || ""}
											renderOption={renderOption}
											getOptionSelected={(option, value) => {
												return value.id === option.id
											}}
											renderInput={(params) => <TextField {...params} variant="outlined" placeholder="Contato" />}
										/>
									</FormControl>
								</div>
								{/* Tipo de mensagem: Texto/Anexo vs Áudio */}
								<FormControl component="fieldset" style={{ margin: '8px 0 4px 0' }}>
									<FormLabel component="legend">Tipo de mensagem</FormLabel>
									<RadioGroup row name="messageType" value={messageType} onChange={handleChangeMessageType}>
										<FormControlLabel value="text" control={<Radio color="primary" />} label="Texto/Anexo" />
										<FormControlLabel
											value="audio"
											control={<Radio color="primary" />}
											label={
												<span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
													Áudio (gravado)
													<Chip
														label="NOVA FUNÇÃO"
														size="small"
														style={{
															backgroundColor: '#4caf50',
															color: 'white',
															fontSize: '10px',
															fontWeight: 'bold',
															height: '20px'
														}}
													/>
												</span>
											}
										/>
									</RadioGroup>
								</FormControl>
								{messageType === 'text' && (
									<>
										<div className={classes.multFieldLine}>
											<Field
												as={TextField}
												rows={9}
												multiline={true}
												label={i18n.t("scheduleModal.form.body")}
												name="body"
												inputRef={messageInputRef}
												error={touched.body && Boolean(errors.body)}
												helperText={touched.body && errors.body}
												variant="outlined"
												margin="dense"
												fullWidth
											/>
										</div>
										<Grid item xs={12} md={12} xl={6}>
											<MessageVariablesPicker
												disabled={isSubmitting}
												onClick={value => handleClickMsgVar(value, setFieldValue)}
											/>
										</Grid>
									</>
								)}

								{messageType === 'audio' && (
									<div style={{ marginTop: 8, marginBottom: 8, minHeight: 360, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
										{/* Linha 1: ação principal (gravar/parar) centralizada */}
										<Grid container spacing={2} alignItems="center" justify="center">
											{!isRecording && !recordedFile && (
												<Grid item>
													<Button
														color="primary"
														variant="contained"
														startIcon={<Mic />}
														onClick={startRecording}
														disabled={isSubmitting}
														size="large"
														style={{ padding: '10px 20px' }}
													>
														Gravar áudio
													</Button>
												</Grid>
											)}
											{isRecording && (
												<>
													<Grid item>
														<Typography variant="body1" color="textSecondary">
															Gravando...
														</Typography>
													</Grid>
													<Grid item>
														<Typography variant="h6" style={{ fontVariantNumeric: 'tabular-nums' }}>
															{fmt(elapsedMs)}
														</Typography>
													</Grid>
													<Grid item>
														<Button
															color="secondary"
															variant="contained"
															startIcon={<Stop />}
															onClick={stopRecording}
															disabled={isSubmitting}
														>
															Parar
														</Button>
													</Grid>
												</>
											)}
										</Grid>
										{/* Nota explicativa alinhada (estado: antes de gravar) */}
										{!isRecording && !recordedFile && (
											<Grid container justify="center" style={{ marginTop: 8 }}>
												<Typography variant="caption" color="textSecondary" align="center">
													No modo áudio, anexos e corpo de mensagem são desativados.
												</Typography>
											</Grid>
										)}

										{/* Nota explicativa alinhada (estado: gravando) */}
										{isRecording && (
											<Grid container justify="center" style={{ marginTop: 8 }}>
												<Typography variant="caption" color="textSecondary" align="center">
													No modo áudio, anexos e corpo de mensagem são desativados.
												</Typography>
											</Grid>
										)}

										{/* Pós-gravação: player centralizado e ações claras */}
										{!isRecording && recordedFile && (
											<Grid container direction="column" alignItems="center" spacing={2} style={{ marginTop: 8 }}>
												<Grid item>
													<Typography variant="subtitle1">Áudio pronto</Typography>
												</Grid>
												<Grid item>
													<Typography variant="body2" color="textSecondary">
														Duração: {fmt(elapsedMs)}
													</Typography>
												</Grid>
												{audioUrl && (
													<Grid item style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
														<audio controls src={audioUrl} style={{ width: '100%', maxWidth: 420 }} />
													</Grid>
												)}
												<Grid item>
													<Chip label={recordedFile.name} />
												</Grid>
												<Grid item>
													<Grid container spacing={2} justify="center">
														<Grid item>
															<Button
																variant="outlined"
																startIcon={<Replay />}
																onClick={() => { discardRecording(); startRecording(); }}
																disabled={isSubmitting}
															>
																Regravar
															</Button>
														</Grid>
														<Grid item>
															<Button
																color="secondary"
																variant="outlined"
																startIcon={<DeleteIcon />}
																onClick={discardRecording}
																disabled={isSubmitting}
															>
																Excluir
															</Button>
														</Grid>
													</Grid>
												</Grid>
												{/* Nota explicativa alinhada (estado: pós-gravação) */}
												<Grid item>
													<Typography variant="caption" color="textSecondary" align="center">
														No modo áudio, anexos e corpo de mensagem são desativados.
													</Typography>
												</Grid>
											</Grid>
										)}

										{recordingError && (
											<Typography color="error" variant="body2" style={{ marginTop: 8 }}>
												{recordingError}
											</Typography>
										)}
									</div>
								)}
								<Grid container spacing={1}>
									<Grid item xs={12} md={6} xl={6}>
										<FormControl
											variant="outlined"
											margin="dense"
											fullWidth
											className={classes.formControl}
										>
											<InputLabel id="whatsapp-selection-label">
												{i18n.t("campaigns.dialog.form.whatsapp")}
											</InputLabel>
																				<Field
												as={Select}
												label={i18n.t("campaigns.dialog.form.whatsapp")}
												placeholder={i18n.t("campaigns.dialog.form.whatsapp")}
												labelId="whatsapp-selection-label"
												id="whatsappIds"
												name="whatsappIds"
												required
												error={touched.whatsappId && Boolean(errors.whatsappId)}
																					value={selectedWhatsapps}
												onChange={(event) => setSelectedWhatsapps(event.target.value)}
											>
												{whatsapps &&
													whatsapps.map((whatsapp) => (
														<MenuItem key={whatsapp.id} value={whatsapp.id}>
															{whatsapp.name}
														</MenuItem>
													))}
											</Field>
										</FormControl>
									</Grid>
									<Grid item xs={12} md={12} xl={6}>
										<FormControl
											variant="outlined"
											margin="dense"
											fullWidth
											className={classes.formControl}
										>
											<InputLabel id="openTicket-selection-label">
												{i18n.t("campaigns.dialog.form.openTicket")}
											</InputLabel>
											<Field
												as={Select}
												label={i18n.t("campaigns.dialog.form.openTicket")}
												placeholder={i18n.t(
													"campaigns.dialog.form.openTicket"
												)}
												labelId="openTicket-selection-label"
												id="openTicket"
												name="openTicket"
												error={
													touched.openTicket && Boolean(errors.openTicket)
												}
											>
												<MenuItem value={"enabled"}>{i18n.t("campaigns.dialog.form.enabledOpenTicket")}</MenuItem>
												<MenuItem value={"disabled"}>{i18n.t("campaigns.dialog.form.disabledOpenTicket")}</MenuItem>
											</Field>
										</FormControl>
									</Grid>
								</Grid>
								<Grid spacing={1} container>
									{/* SELECIONAR USUARIO */}
									<Grid item xs={12} md={6} xl={6}>
										<Autocomplete
											style={{ marginTop: '8px' }}
											variant="outlined"
											margin="dense"
											className={classes.formControl}
											getOptionLabel={(option) => `${option.name}`}
											value={selectedUser}
											size="small"
											onChange={(e, newValue) => {
												setSelectedUser(newValue);
												if (newValue != null && Array.isArray(newValue.queues)) {
													if (newValue.queues.length === 1) {
														setSelectedQueue(newValue.queues[0].id);
													}
													setQueues(newValue.queues);

												} else {
													setQueues(allQueues);
													setSelectedQueue("");
												}
											}}
											options={options}
											filterOptions={filterOptions}
											freeSolo
											fullWidth
											disabled={values.openTicket === "disabled"}
											autoHighlight
											noOptionsText={i18n.t("transferTicketModal.noOptions")}
											loading={loading}
											renderOption={option => (<span> <UserStatusIcon user={option} /> {option.name}</span>)}
											renderInput={(params) => (
												<TextField
													{...params}
													label={i18n.t("transferTicketModal.fieldLabel")}
													variant="outlined"
													onChange={(e) => setSearchParam(e.target.value)}
													InputProps={{
														...params.InputProps,
														endAdornment: (
															<React.Fragment>
																{loading ? (
																	<CircularProgress color="inherit" size={20} />
																) : null}
																{params.InputProps.endAdornment}
															</React.Fragment>
														),
													}}
												/>
											)}
										/>
									</Grid>

									<Grid item xs={12} md={6} xl={6}>
										<FormControl
											variant="outlined"
											margin="dense"
											fullWidth
											className={classes.formControl}
										>
											<InputLabel>
												{i18n.t("transferTicketModal.fieldQueueLabel")}
											</InputLabel>
											<Select
												value={selectedQueue}
												onChange={(e) => setSelectedQueue(e.target.value)}
												label={i18n.t("transferTicketModal.fieldQueuePlaceholder")}
												disabled={values.openTicket === "disabled"}
											>
												{queues.map((queue) => (
													<MenuItem key={queue.id} value={queue.id}>
														{queue.name}
													</MenuItem>
												))}
											</Select>
										</FormControl>
									</Grid>
								</Grid>
								<Grid spacing={1} container style={{ marginTop: '-10px' }}>
									<Grid item xs={12} md={6} xl={6}>
										<FormControl
											variant="outlined"
											margin="dense"
											fullWidth
											className={classes.formControl}
										>
											<InputLabel id="statusTicket-selection-label">
												{i18n.t("campaigns.dialog.form.statusTicket")}
											</InputLabel>
											<Field
												as={Select}
												disabled={values.openTicket === "disabled"}
												label={i18n.t("campaigns.dialog.form.statusTicket")}
												placeholder={i18n.t(
													"campaigns.dialog.form.statusTicket"
												)}
												labelId="statusTicket-selection-label"
												id="statusTicket"
												name="statusTicket"
												error={
													touched.statusTicket && Boolean(errors.statusTicket)
												}
											>
												<MenuItem value={"closed"}>{i18n.t("campaigns.dialog.form.closedTicketStatus")}</MenuItem>
												<MenuItem value={"open"}>{i18n.t("campaigns.dialog.form.openTicketStatus")}</MenuItem>
											</Field>
										</FormControl>
									</Grid>

									<Grid item xs={12} md={6} xl={6}>
										<Field name="sendAt">
											{({ field, form }) => {
												// Durante a digitação: valida live e mostra aviso imediatamente se < 10 minutos
												const handleChange = (e) => {
													const raw = e.target.value;
													form.setFieldValue('sendAt', raw, false);
													const next = moment(raw);
													const min10 = moment().add(10, 'minutes');
													if (next.isValid() && next.isBefore(min10)) {
														setSendAtWarn('O mínimo é 10 minutos. Ajustaremos para 15 minutos ao sair do campo.');
														form.setFieldTouched('sendAt', true, false);
													} else {
														setSendAtWarn('');
														form.setFieldTouched('sendAt', true, false);
													}
												};

												// Ao sair do campo: valida mínimo de 10 minutos e, se menor, ajusta para 15 minutos
												const handleBlur = (e) => {
													const raw = e.target.value;
													const min = moment(minSendAt, 'YYYY-MM-DDTHH:mm');
													const next = moment(raw);
													if (!next.isValid()) {
														// Deixa o Yup mostrar o erro padrão ao sair
														setSendAtWarn('');
														return;
													}
													if (next.isBefore(min)) {
														// Se o usuário escolheu uma data inferior ao mínimo (10 min), ajustamos para 15 min
														const clamped = moment().add(15, 'minutes').format('YYYY-MM-DDTHH:mm');
														form.setFieldValue('sendAt', clamped, false);
														setSendAtWarn('O mínimo é 10 minutos. Ajustamos para 15 minutos à frente. Confira antes de salvar.');
													} else {
														setSendAtWarn('');
													}
												};
												const warnActive = Boolean(sendAtWarn) && !errors.sendAt;
												const helperProps = warnActive ? { classes: { root: classes.helperWarn } } : undefined;
												return (
													<TextField
														{...field}
														label={i18n.t('scheduleModal.form.sendAt')}
														type="datetime-local"
														inputProps={{ min: minSendAt }}
														className={warnActive ? classes.warnField : undefined}
														error={Boolean(errors.sendAt)}
														helperText={errors.sendAt || sendAtWarn}
														FormHelperTextProps={helperProps}
														variant="outlined"
														fullWidth
														size="small"
														style={{ marginTop: '8px' }}
														onChange={handleChange}
														onBlur={handleBlur}
													/>
												);
											}}
										</Field>
									</Grid>
									<Grid item xs={12} md={6} xl={6}>
										<FormControlLabel
											control={
												<Field
													as={Switch}
													color="primary"
													name="assinar"
													checked={values.assinar}
													disabled={values.openTicket === "disabled"}
												/>
											}
											label={i18n.t("scheduleModal.form.assinar")}
										/>
									</Grid>
								</Grid>
								<h3>Recorrência</h3>
								<p>
									Você pode escolher enviar a mensagem de forma recorrente e
									escolher o intervalo. Caso seja uma mensagem a ser enviada
									uma unica vez, não altere nada nesta seção.
								</p>
								<br />
								<Grid container spacing={1}>
									<Grid item xs={12} md={4} xl={4}>
										<FormControl size="small" fullWidth variant="outlined">
											<InputLabel id="demo-simple-select-label">Intervalo</InputLabel>
											<Select
												labelId="demo-simple-select-label"
												id="demo-simple-select"
												value={intervalo}
												// name="intervalo"
												onChange={(e) =>
													setIntervalo(e.target.value || 1)
												}
												label="Intervalo"
											>
												<MenuItem value={1}>Dias</MenuItem>
												<MenuItem value={2}>Semanas</MenuItem>
												<MenuItem value={3}>Meses</MenuItem>
												<MenuItem value={4}>Minutos</MenuItem>
											</Select>
										</FormControl>
									</Grid>

									<Grid item xs={12} md={4} xl={4}>
										<Field
											as={TextField}
											label="Valor do Intervalo"
											name="valorIntervalo"
											size="small"
											error={touched.valorIntervalo && Boolean(errors.valorIntervalo)}
											InputLabelProps={{ shrink: true }}
											variant="outlined"
											fullWidth
										/>
									</Grid>
				    <Grid item xs={12} md={4} xl={4}>
										<Field
											as={TextField}
											label="Enviar quantas vezes"
											name="enviarQuantasVezes"
											size="small"
											error={
												touched.enviarQuantasVezes &&
												Boolean(errors.enviarQuantasVezes)
											}
					    helperText={touched.enviarQuantasVezes && errors.enviarQuantasVezes || "Até 25 repetições"}
					    type="number"
					    InputProps={{ inputProps: { min: 1, max: 25 } }}
											variant="outlined"
											fullWidth
										/>
									</Grid>
									<Grid item xs={12} md={12} xl={12}>
										<FormControl size="small" fullWidth variant="outlined">
											<InputLabel id="demo-simple-select-label">Enviar quantas vezes</InputLabel>
											<Select
												labelId="demo-simple-select-label"
												id="demo-simple-select"
												value={tipoDias}
												onChange={(e) =>
													setTipoDias(e.target.value || 4)
												}
												label="Enviar quantas vezes"
											>
												<MenuItem value={4}>Enviar normalmente em dias não úteis</MenuItem>
												<MenuItem value={5}>Enviar um dia útil antes</MenuItem>
												<MenuItem value={6}>Enviar um dia útil depois</MenuItem>
											</Select>
										</FormControl>
									</Grid>
								</Grid>
								{(schedule.mediaPath || attachment) && messageType === 'text' && (
									<Grid xs={12} item>
										<Button startIcon={<AttachFile />}>
											{attachment ? attachment.name : schedule.mediaName}
										</Button>
										<IconButton
											onClick={() => setConfirmationOpen(true)}
											color="secondary"
										>
											<DeleteOutline color="secondary" />
										</IconButton>
									</Grid>
								)}
							</DialogContent>
							<DialogActions>
								{(!attachment && !schedule.mediaPath && messageType === 'text') && (
									<Button
										color="primary"
										onClick={() => attachmentFile.current.click()}
										disabled={isSubmitting}
										variant="outlined"
									>
										{i18n.t("quickMessages.buttons.attach")}
									</Button>
								)}
								<Button
									onClick={handleClose}
									color="secondary"
									disabled={isSubmitting}
									variant="outlined"
								>
									{i18n.t("scheduleModal.buttons.cancel")}
								</Button>
								{(schedule.sentAt === null || schedule.sentAt === "") && (
									<Button
										type="submit"
										color="primary"
										disabled={(() => {
											if (isSubmitting) return true;
											const v = moment(values.sendAt);
											if (!v.isValid()) return true;
											return v.isBefore(moment().add(10, 'minutes'));
										})()}
										variant="contained"
										className={classes.btnWrapper}
									>
										{scheduleId
											? `${i18n.t("scheduleModal.buttons.okEdit")}`
											: `${i18n.t("scheduleModal.buttons.okAdd")}`}
										{isSubmitting && (
											<CircularProgress
												size={24}
												className={classes.buttonProgress}
											/>
										)}
									</Button>
								)}
							</DialogActions>
						</Form>
					)}
				</Formik>
			</Dialog>
		</div>
	);
};

export default ScheduleModal;